import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from "../context/CartContext";
import { useRef, useState, useEffect } from "react";

export default function Header() {
  const { user, logout } = useAuth();
  const { cart, removeFromCart, totalItems, totalPrice } = useCart();
  const [open, setOpen] = useState(false);
  const cartRef = useRef();

  // Lukk dropdown hvis du klikker utenfor
  useEffect(() => {
    const handleClick = (e) => {
      if (cartRef.current && !cartRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <header className="bg-[#000099] text-white p-4 flex justify-between items-center">
      <Link to="/">
        <img src="/logosmall.png" alt="Ryfylke Utleie" className="h-10" />
      </Link>

      <nav className="flex items-center space-x-6">
        {/* CART ICON + DROPDOWN */}
        <div className="relative" ref={cartRef}>
          <button
            onClick={() => setOpen(o => !o)}
            className="relative"
            aria-label="Handlekurv"
          >
            <span className="relative">
              {/* NYTT ikon, HELT HVITT */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="currentColor"
                viewBox="0 0 256 256"
                className="text-white"
              >
                <path d="M230.14,58.87A8,8,0,0,0,224,56H62.68L56.6,22.57A8,8,0,0,0,48.73,16H24a8,8,0,0,0,0,16h18L67.56,172.29a24,24,0,0,0,5.33,11.27,28,28,0,1,0,44.4,8.44h45.42A27.75,27.75,0,0,0,160,204a28,28,0,1,0,28-28H91.17a8,8,0,0,1-7.87-6.57L80.13,152h116a24,24,0,0,0,23.61-19.71l12.16-66.86A8,8,0,0,0,230.14,58.87ZM104,204a12,12,0,1,1-12-12A12,12,0,0,1,104,204Zm96,0a12,12,0,1,1-12-12A12,12,0,0,1,200,204Zm4-74.57A8,8,0,0,1,196.1,136H77.22L65.59,72H214.41Z"></path>
              </svg>
              {totalItems > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-600 text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {totalItems}
                </span>
              )}
            </span>
          </button>
          {/* DROPDOWN */}
          {open && (
            <div className="absolute right-0 mt-2 w-72 bg-white text-black rounded-lg shadow-lg z-50 p-4">
              <h3 className="font-bold text-lg mb-2 text-[#000099]">Handlekurv</h3>
              {cart.length === 0 ? (
                <p className="text-gray-600">Handlekurven er tom.</p>
              ) : (
                <ul className="divide-y divide-gray-200 max-h-56 overflow-auto">
                  {cart.map(item => (
                    <li key={item.id} className="flex items-center justify-between py-2">
                      <div>
                        <div className="font-medium">{item.name}</div>
                        <div className="text-sm text-gray-500">
                          Antall: {item.quantity}
                        </div>
                        <div className="text-xs text-gray-400">
                          {item.price} kr/stk
                        </div>
                      </div>
                      <button
                      className="bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center ml-2 text-xs"
                      onClick={() => removeFromCart(item.id, item.date_from, item.date_to)}
                      title="Fjern"
                    >
                      ×
                    </button>
                    </li>
                  ))}
                </ul>
              )}
            {cart.length > 0 && (
              <div className="mt-3">
                <div className="flex justify-between font-bold">
                  <span>Sum:</span>
                  <span>{totalPrice} kr</span>
                </div>
                <Link
                  to={user ? "/cart" : "/login"}
                  onClick={() => setOpen(false)}
                  className="mt-4 block w-full bg-[#000099] text-white text-center py-2 rounded hover:bg-blue-900 transition"
                >
                  {user ? "Gå til kasse" : "Logg inn for å gå til kasse"}
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>
        {/* LOGIN/ADMIN/USER */}
        {user ? (
          <>
            {user.role === 'admin' && (
              <Link to="/admin" className="hover:underline">Admin</Link>
            )}
            {/* Link til profilsiden på brukernavn */}
            <Link
              to="/profile"
              className="ml-4 underline font-semibold hover:text-blue-300 transition"
              title="Se min profil"
            >
              Innlogget som <strong>{user.name}</strong>
            </Link>
            <button onClick={logout} className="ml-4 underline text-sm hover:text-red-300">Logg ut</button>
          </>
        ) : (
          <>
            <Link to="/login" className="hover:underline">Logg inn</Link>
            <Link to="/register" className="hover:underline">Registrer</Link>
          </>
        )}
      </nav>
    </header>
  );
}
